export default __webpack_public_path__ + "static/faq-486342c9c7571857374ca37aa6543fbb.png";